/* =========================================================
   File: assets/sh-calc-project-summary.js
   Capital Floorings - Final Price Summary Controller
========================================================= */

(function () {
  'use strict';

  if (window.__shCalcProjectSummaryFinalLoaded) return;
  window.__shCalcProjectSummaryFinalLoaded = true;

  function formatNumber(value) {
    value = Number(value || 0);

    if (!Number.isFinite(value)) return '0';
    if (Number.isInteger(value)) return String(value);

    return value.toFixed(2).replace(/\.?0+$/, '');
  }

  function formatMoney(cents, moneyFormat) {
    cents = Number(cents || 0);

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat || '${{amount}}');
    }

    return '$' + (cents / 100).toFixed(2);
  }

  function normalizeQty(qty) {
    qty = Math.ceil(Number(qty || 1));
    return qty < 1 ? 1 : qty;
  }

  function getVariantId(root) {
    var section = root.closest('section') || document;
    var idInput =
      section.querySelector('form[action*="/cart/add"] [name="id"]') ||
      document.querySelector('form[action*="/cart/add"] [name="id"]');

    if (!idInput) return '';

    if (idInput.tagName === 'SELECT') return idInput.value;

    if (idInput.type === 'radio') {
      var checked =
        section.querySelector('form[action*="/cart/add"] [name="id"]:checked') ||
        document.querySelector('form[action*="/cart/add"] [name="id"]:checked');

      return checked ? checked.value : idInput.value;
    }

    return idInput.value;
  }

  function findProjectInput(root) {
    var section = root.closest('section') || document;

    return (
      section.querySelector('[data-project-size-input]') ||
      section.querySelector('[data-sh-room-area-input]') ||
      section.querySelector('[data-room-area-input]') ||
      section.querySelector('[data-sh-area-input]') ||
      section.querySelector('[data-project-area-input]') ||
      document.querySelector('[data-project-size-input]') ||
      document.querySelector('[data-sh-room-area-input]') ||
      document.querySelector('[data-room-area-input]') ||
      document.querySelector('[data-sh-area-input]') ||
      document.querySelector('[data-project-area-input]')
    );
  }

  function syncShopifyQuantity(root, qty) {
    var section = root.closest('section') || document;

    var formQty =
      section.querySelector('form[action*="/cart/add"] [name="quantity"]') ||
      document.querySelector('form[action*="/cart/add"] [name="quantity"]');

    if (formQty) {
      formQty.value = qty;
      formQty.dispatchEvent(new Event('change', { bubbles: true }));
    }

    var mainQty =
      section.querySelector('[data-main-quantity-input]') ||
      document.querySelector('[data-main-quantity-input]');

    if (mainQty) {
      mainQty.value = qty;
      mainQty.dispatchEvent(new Event('change', { bubbles: true }));
    }

    var oldBoxQty =
      section.querySelector('.sh-flooring-calculator [data-box-quantity-input]') ||
      document.querySelector('.sh-flooring-calculator [data-box-quantity-input]');

    if (oldBoxQty && !root.contains(oldBoxQty)) {
      oldBoxQty.value = qty;
      oldBoxQty.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function initSummary(root) {
    if (!root || root.__shCalcReady) return;
    root.__shCalcReady = true;

    var configEl = root.querySelector('[data-sh-calc-summary-config]');
    if (!configEl) return;

    var config = {};

    try {
      config = JSON.parse(configEl.textContent);
    } catch (error) {
      console.warn('SH calc summary JSON error:', error);
      return;
    }

    var variants = Array.isArray(config.variants) ? config.variants : [];
    var activeVariant =
      variants.find(function (variant) {
        return String(variant.id) === String(config.selectedVariantId);
      }) || variants[0];

    if (!activeVariant) return;

    var projectInput = findProjectInput(root);
    var contingencyInput = root.querySelector('[data-sh-calc-contingency-checkbox]');
    var recalculateBtn = root.querySelector('[data-sh-calc-recalculate]');

    var qtyInput = root.querySelector('[data-sh-calc-qty-input]');
    var qtyMinus = root.querySelector('[data-sh-calc-qty-minus]');
    var qtyPlus = root.querySelector('[data-sh-calc-qty-plus]');

    var stockPill = root.querySelector('[data-sh-calc-stock-pill]');
    var stockText = root.querySelector('[data-sh-calc-stock-text]');
    var subtotalOutput = root.querySelector('[data-sh-calc-subtotal]');
    var coverageOutput = root.querySelector('[data-sh-calc-coverage]');
    var coverageUnitOutput = root.querySelector('[data-sh-calc-coverage-unit]');
    var totalCoverageOutput = root.querySelector('[data-sh-calc-user-total-coverage]');
    var totalCoverageUnit = root.querySelector('[data-sh-calc-user-total-unit]');
    var boxesOutput = root.querySelector('[data-sh-calc-boxes]');
    var boxLabel = root.querySelector('[data-sh-calc-box-label]');
    var boxPriceOutput = root.querySelector('[data-sh-calc-box-price]');
    var unitPriceOutput = root.querySelector('[data-sh-calc-unit-price]');
    var priceUomOutput = root.querySelector('[data-sh-calc-price-uom]');
    var priceUomInline = root.querySelector('[data-sh-calc-price-uom-inline]');
    var pricePerUnitInline = root.querySelector('[data-sh-calc-price-per-unit-inline]');

    var manualQty = 1;

    function getMultiplier() {
      return contingencyInput && contingencyInput.checked ? 1.1 : 1;
    }

    function getProjectValue() {
      var value = projectInput ? Number(projectInput.value || 0) : 0;
      return Number.isFinite(value) && value > 0 ? value : 0;
    }

    function getCoveragePerBox() {
      var value = Number(activeVariant.coveragePerBox || 1);
      return value > 0 ? value : 1;
    }

    function getRequiredQty() {
      var coveragePerBox = getCoveragePerBox();
      var projectValue = getProjectValue();

      if (projectValue > 0) {
        return normalizeQty((projectValue * getMultiplier()) / coveragePerBox);
      }

      return normalizeQty(manualQty * getMultiplier());
    }

    function getDisplayedTotalCoverage(qty) {
      var projectValue = getProjectValue();

      if (projectValue > 0) {
        return projectValue * getMultiplier();
      }

      return qty * getCoveragePerBox();
    }

    function update() {
      var coveragePerBox = getCoveragePerBox();
      var qty = getRequiredQty();
      var totalCoverage = getDisplayedTotalCoverage(qty);
      var pricePerUnit = activeVariant.price / coveragePerBox;

      if (qtyInput) qtyInput.value = qty;

      if (subtotalOutput) {
        subtotalOutput.textContent = formatMoney(activeVariant.price * qty, config.moneyFormat);
      }

      if (coverageOutput) {
        coverageOutput.textContent = formatNumber(coveragePerBox);
      }

      if (coverageUnitOutput) {
        coverageUnitOutput.textContent = activeVariant.metricUnit || 'sq ft';
      }

      if (totalCoverageOutput) {
        totalCoverageOutput.textContent = formatNumber(totalCoverage);
      }

      if (totalCoverageUnit) {
        totalCoverageUnit.textContent = activeVariant.totalUnit || activeVariant.priceUom || 'SQFT';
      }

      if (boxesOutput) {
        boxesOutput.textContent = qty;
      }

      if (boxLabel) {
        boxLabel.textContent = qty > 1 ? 'Boxes' : 'Box';
      }

      if (boxPriceOutput) {
        boxPriceOutput.textContent = formatMoney(activeVariant.price, config.moneyFormat);
      }

      if (unitPriceOutput) {
        unitPriceOutput.textContent = formatMoney(pricePerUnit, config.moneyFormat);
      }

      if (pricePerUnitInline) {
        pricePerUnitInline.textContent = formatMoney(pricePerUnit, config.moneyFormat);
      }

      if (priceUomOutput) {
        priceUomOutput.textContent = activeVariant.priceUom || 'SQFT';
      }

      if (priceUomInline) {
        priceUomInline.textContent = activeVariant.priceUom || 'SQFT';
      }

      if (stockPill && stockText) {
        if (activeVariant.available) {
          stockPill.classList.remove('is-out');
          stockText.textContent = 'In Stock';
        } else {
          stockPill.classList.add('is-out');
          stockText.textContent = 'Out of Stock';
        }
      }

      syncShopifyQuantity(root, qty);
    }

    function setVariantById(variantId) {
      var nextVariant = variants.find(function (variant) {
        return String(variant.id) === String(variantId);
      });

      if (!nextVariant) return;

      activeVariant = nextVariant;
      manualQty = 1;
      update();
    }

    function setManualQtyFromVisible(desiredQty) {
      desiredQty = normalizeQty(desiredQty);
      manualQty = desiredQty / getMultiplier();
      update();
    }

    if (projectInput) {
      projectInput.addEventListener('input', update);
      projectInput.addEventListener('change', update);
    }

    if (contingencyInput) {
      contingencyInput.addEventListener('change', update);
    }

    if (qtyInput) {
      qtyInput.addEventListener('input', function () {
        setManualQtyFromVisible(qtyInput.value);
      });

      qtyInput.addEventListener('blur', function () {
        setManualQtyFromVisible(qtyInput.value);
      });
    }

    if (qtyMinus) {
      qtyMinus.addEventListener('click', function (event) {
        event.preventDefault();
        setManualQtyFromVisible(Number(qtyInput ? qtyInput.value : manualQty) - 1);
      });
    }

    if (qtyPlus) {
      qtyPlus.addEventListener('click', function (event) {
        event.preventDefault();
        setManualQtyFromVisible(Number(qtyInput ? qtyInput.value : manualQty) + 1);
      });
    }

    if (recalculateBtn) {
      recalculateBtn.addEventListener('click', function (event) {
        event.preventDefault();
        update();
      });
    }

    document.addEventListener('change', function (event) {
      if (event.target && event.target.name === 'id') {
        setVariantById(event.target.value);
      }
    });

    document.addEventListener('variant:change', function (event) {
      if (event.detail && event.detail.variant && event.detail.variant.id) {
        setVariantById(event.detail.variant.id);
      } else {
        setVariantById(getVariantId(root));
      }
    });

    document.addEventListener('variant:changed', function (event) {
      if (event.detail && event.detail.variant && event.detail.variant.id) {
        setVariantById(event.detail.variant.id);
      } else {
        setVariantById(getVariantId(root));
      }
    });

    document.addEventListener('product:variant-change', function (event) {
      if (event.detail && event.detail.variant && event.detail.variant.id) {
        setVariantById(event.detail.variant.id);
      } else {
        setVariantById(getVariantId(root));
      }
    });

    setInterval(function () {
      var currentVariantId = getVariantId(root);

      if (currentVariantId && String(currentVariantId) !== String(activeVariant.id)) {
        setVariantById(currentVariantId);
      }
    }, 350);

    update();
  }

  function initAll() {
    document.querySelectorAll('[data-sh-calc-project-summary]').forEach(initSummary);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
